import { getFunctions, httpsCallable } from 'firebase/functions';
import { notifySuccess, notifyError } from '../utils/alerts';

export const enviarPruebaWhatsApp = async (payload) => {
    const functions = getFunctions();
    
    
    const enviarNotificacion = httpsCallable(functions, 'enviarNotificacionesWhatsApp');

    try {
        const response = await enviarNotificacion(payload);
        
        // Firebase devuelve la respuesta del backend en la propiedad .data
        if (response.data.success) {
            notifySuccess('¡Backend en acción!', `WhatsApp enviado vía Firebase. SID: ${response.data.sid}`);
        }
    } catch (error) {
        console.error('Error al llamar a la función:', error);
        // El error de Firebase Functions suele venir en error.message
        notifyError('Error de Backend', error.message || 'La función falló');
    }
};